import { ValidatorFn } from '@angular/forms';

export const confirmPasswordValidator: ValidatorFn = (control) => {
  const rawPassword = control.get('rawPassword');
  const confirmPassword = control.get('confirmPassword');
  if (!(rawPassword && confirmPassword)) {
    return { invalidField: true };
  }

  if (!confirmPassword.value) {
    confirmPassword.setErrors({
      noConfirmPassword: '確認用パスワードを入力してください。',
    });
    return null;
  }

  if (rawPassword.value !== confirmPassword.value) {
    confirmPassword.setErrors({
      differentPassword: 'パスワードが一致しません。',
    });
    return null;
  }

  return null;
};
